import { IDayRangeCommon } from '@common/utils/get-events/get-events.util';
import dayjs from 'dayjs';
import { IPause } from '../item-generated-api';

export interface IPauseDto extends IPause, IDayRangeCommon {
    pauseBillingDate: Date;
    resumeBillingDate: Date;
    pauseDeliveryDate: Date;
    resumeDeliveryDate: Date;
}
export const createPauseDto = (source: IPause, cutOff: number): IPauseDto => {
    return {
        ...source,
        pauseBillingDate: dayjs((source.pause_date || 0) * 1000)
            .set('seconds', 0)
            .toDate(),
        resumeBillingDate: dayjs((source.resume_date || 0) * 1000)
            .set('seconds', 0)
            .toDate(),
        pauseDeliveryDate: dayjs((source.pause_date || 0) * 1000)
            .set('seconds', 0)
            .add(cutOff, 'day')
            .toDate(),
        resumeDeliveryDate: dayjs((source.resume_date || 0) * 1000)
            .set('seconds', 0)
            .add(cutOff, 'day')
            .toDate(),

        startDate: dayjs((source.pause_date || 0) * 1000).toDate(),
        endDate: dayjs((source.resume_date || 0) * 1000).toDate(),
    };
};
